getPmSectionDataCreated